import { createApp } from '@o-din/app';

import Maintenance from '@o-din-maintenance/src/o-din-maintenance';
import Report from '@o-din-report/src/o-din-report';

createApp('#app', [Maintenance, Report]);
